import Navbar from "./components/General/NavBar/navbar";
import Footer from "./components/General/Footer/footer";
import Home from "./pages/Home";
import About from "./pages/About";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Project from "./pages/Project";
import User from "./pages/User";
import UserList from "./pages/UserList";
import ProjectList from "./pages/ProjectList";
import MyProjects from "./pages/MyProjects";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Inbox from "./pages/Inbox";
import StartProjectContent from './components/StartProject/StartProjectContent/startprojectcontent';
import Logout from "./components/Authentication/AuthSvc/logout";
import { useState } from "react";
import MyProfileContent from "./components/MyProfile/MyProfileContent/myprofilecontent";
import EditProjectContent from "./components/EditProject/EditProjectContent/editprojectcontent";
import ImageUpload from "./components/imageupload/imageupload";
import ResetPassword from './components/Authentication/ResetPassword/resetpassword';
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Chat from "./pages/Chat";
import './theme-variables.css';         

// new feedback button
import Feedback from "./components/Feedback/FeedbackContent/Feedback";

function App() {

  const [loginstate,setLoginState] = useState({isLoggedIn: false, loginId: localStorage.getItem('loginId')});

  return (
    <div className="App">
      <Router>
      <Navbar loginstate={loginstate} setLoginState={setLoginState}/>
      <Feedback/>
      <Routes>
        <Route path='/' exact Component={Home}/>
        <Route path='/about' exact Component={About}/>
        <Route path='/project/:id' exact Component={Project}/>
        <Route path='/user/:id' exact Component={User}/>
        <Route path='/userlist' exact Component={UserList}/>
        <Route path='/projectlist' exact Component={ProjectList}/>
        <Route path='/myprojects/:id' element={<MyProjects loginstate={loginstate}/>}/>
        <Route path='/login' element={<Login loginstate={loginstate} setLoginState={setLoginState}/>}/>
        <Route path='/signup' exact Component={SignUp}/>
        <Route path='/contact' exact Component={Contact}/>
        <Route path='/faq' exact Component={FAQ}/>
        <Route path='/startproject' exact Component={StartProjectContent}/>
        <Route path='/myprofile/:id' exact Component={MyProfileContent}/>
        <Route path='/logout' element={<Logout loginstate={loginstate} setLoginState={setLoginState}/>}/>
        <Route path='/editproject/:id' exact Component={EditProjectContent}/>
        <Route path='/imageupload' exact Component={ImageUpload}/>
        <Route path='/inbox' exact Component={Inbox}/>
        <Route path='/reset-password/:token' element={<ResetPassword/>}/>
        <Route path='/dashboard' exact Component={Dashboard}/>
        <Route path='/admin' exact Component={Admin}/>
        <Route path='/chat' element={<Chat />} />  // For direct messages with query params
        <Route path='/chat/project/:id' element={<Chat />} /> // For project chats
      </Routes>
      <Footer/>
    </Router>
      {/* <Intro/>
      <About/>
      <Projects/>
      <Contact/>
      <Footer/> */}
    </div>
  );
}

export default App;
